import { render, staticRenderFns } from "./CSCWCMDialog.vue?vue&type=template&id=f4c42b78&scoped=true&"
import script from "./CSCWCMDialog.vue?vue&type=script&lang=tsx&"
export * from "./CSCWCMDialog.vue?vue&type=script&lang=tsx&"
import style0 from "./CSCWCMDialog.vue?vue&type=style&index=0&id=f4c42b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c42b78",
  null
  
)

export default component.exports